import { useCallback } from 'react';
import Button from 'components/Button';
import FilterCondition from '../FilterCondition';
import { Divider } from '../styled';
import { Container } from './styled';

interface FilterGroupProps {
    conditions?: any[];
    onChange?: (value: any[]) => void;
}

const FilterGroup = ({
    conditions = [],
    onChange = () => {},
}: FilterGroupProps) => {
    const handleRemoveCondition = useCallback(
        (index: number) => {
            const newConditions = [...conditions];
            newConditions.splice(index, 1);
            onChange(newConditions);
        },
        [conditions, onChange],
    );

    const handleUpdateCondition = useCallback(
        (index: number, value: any) => {
            const newConditions = [...conditions];
            newConditions.splice(index, 1, value);
            onChange(newConditions);
        },
        [conditions, onChange],
    );

    const handleAddCondition = useCallback(
        () => onChange([
            ...conditions,
            {
                a: '',
                o: '',
                b: '',
            },
        ]),
        [conditions, onChange],
    );

    return (
        <Container>
            {conditions?.map((condition, index) => {
                const key = `filter-condition-${index}`;
                return (
                    <>
                        <FilterCondition
                            key={key}
                            condition={condition}
                            onChange={(value: any) => handleUpdateCondition(index, value)}
                            onRequestRemove={() => handleRemoveCondition(index)}
                        />
                        <Divider label="AND" />
                    </>
                );
            })}
            <Button
                variant="base"
                label="Add Condition"
                borderRadius="semi-rounded"
                onClick={handleAddCondition}
            />
        </Container>
    );
};

export default FilterGroup;
